import React from 'react'

import {
    Box,
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon
} from '@salesforce/retail-react-app/app/components/shared/ui'
import { FormattedMessage } from 'react-intl'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../../utils/site-config'

/* Styles */
import { useMyRewardsStyles } from '../styles/myRewardsStyles'

/* Icons */
import { ChevronDownIcon } from '../../../components/icons'

/* Hooks */
import { useOptimizely } from '../../../contexts/optimizely-context'

/* Components */
import Link from '@salesforce/retail-react-app/app/components/link'

/* Utils */
import { renderComponentsSwitch, renderLayoutsSwitch } from '../../../components/optimizely/utils/contentRenderer'
import { generateStyles } from '../../../components/optimizely/utils/utils'

const FAQ = () => {
    const {app: appConfig} = getConfig()
    const {site} = useMultiSite()
    const siteId = site?.id
    const { rewardPageBlock } = useOptimizely()
    const styles = useMyRewardsStyles()
    const faqStyle = styles?.components?.faq

    // This will fallback CMS
    const hardCodedData = {
        title: 'FAQ',
        subTitle: 'Got Questions? We’ve got answers!',
        readAllLoyaltyFAQ: 'Read all loyalty FAQs',
        tabs: [{
            name: 'What is Garage & Dynamite Collectif?',
            content: "The Garage Collectif is more than a loyalty program, and more than the sum of its parts. It's a community of our unique Garage shoppers coming together for their love of fashion, while also making the most of exclusive benefits, including member pricing, a redeemable points system, early access to drops, and other perks."
        }, {
            name: 'How do I sign up?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'What benefits do I get if I sign up?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'Does it cost anything to join?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'How do I earn points? ',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'How long do I have my current tier status for?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'If I was already a member of the Garage Studio program, does my account carry over?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }, {
            name: 'Can I earn points on past purchases?',
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam."
        }]
    }

    return (
        <Box {...faqStyle.container}
            {...styles.componentWrapper}>
            {rewardPageBlock ? (
                renderComponentsSwitch(rewardPageBlock?.FAQPreTitleResponsiveText?.Expanded)
            ) : (
                <Text {...faqStyle.title}>
                    {hardCodedData.title}
                </Text>
            )}

            {rewardPageBlock ? (
                renderComponentsSwitch(rewardPageBlock?.FAQTitleResponsiveText?.Expanded)
            ) : (
                <Text {...styles.sectionTitle}>
                    {hardCodedData.subTitle}
                </Text>
            )}

            {rewardPageBlock ? (
                <Box {...faqStyle.acc} borderTop={'1px solid'} borderColor={'black'}>
                    {rewardPageBlock?.FAQItemList?.map((faqItem, index) => {
                        return renderLayoutsSwitch(faqItem?.ContentLink?.Expanded, {
                            overwriteXHtmlBlockTitleStyle: {
                                mb: 0,
                                pb: {base: 5, lg: '18px'},
                                pt: {base: 5, lg: '18px'}
                            },
                            overwriteXHtmlBlockCollapsibleWrapperStyle: {
                                marginBottom: 0,
                            },
                            overwriteXHtmlBlockBulletWrapperStyle: {
                                mt: 0,
                                pb: {base: 4},
                                pr: {base: 10}
                            },
                            isTabOpen: index === 0
                        })
                    })}
                </Box>
            ) : (
                <Accordion defaultIndex={[0]} allowMultiple {...faqStyle.acc}>
                    {hardCodedData?.tabs.map((tab, tabIndex) => {
                        return (
                            <AccordionItem {...faqStyle.accItem} key={`faqTab-${tabIndex}`}>
                                <AccordionButton data-testid={`faq-accordion-button-${tabIndex}`} {...faqStyle.accBtn}>
                                    <Box as='span' {...faqStyle.accTitle}>
                                        {tab.name}
                                    </Box>
                                    <AccordionIcon as={ChevronDownIcon} />
                                </AccordionButton>
                                <AccordionPanel {...faqStyle.accPanel}>
                                    <Text>
                                        {tab.content}
                                    </Text>
                                </AccordionPanel>
                            </AccordionItem>
                        )
                    })}
                </Accordion>
            )}
            <Box {...faqStyle.footerCopy}>
                {rewardPageBlock ? (
                    rewardPageBlock?.FAQCTA?.map((fCta) => {
                        return renderComponentsSwitch(fCta?.ContentLink?.Expanded, {
                            stylingTextOverwrite: {
                                fontSize: {base: 'sm'},
                                lineHeight: {base: '20px'},
                                fontWeight: {base: 'normal'}
                            },
                            ContainerCustomStyling: {
                                width: '100%'
                            }
                        })
                    })
                ) : (
                    <Link textDecoration='underline' to='/my-rewards'>
                        {hardCodedData.readAllLoyaltyFAQ}
                    </Link>
                )}
                {rewardPageBlock ? (
                    <Text {...generateStyles(rewardPageBlock?.RewardFooterTextStyle, {...faqStyle.footerCopyWrapper})}
                        dangerouslySetInnerHTML={{ __html:  rewardPageBlock?.RewardFooterText}}
                    />
                ) : (
                    <Text {...faqStyle.footerCopy}>
                        <FormattedMessage
                            id="faq_terms"
                            defaultMessage="For any other inquiries, please check out our <terms>Terms and Conditions</terms> or contact our <customer>Customer Service</customer> at 1-888-882-1138 (Canada) or 1-888-342-7243 (USA)."
                            values={{
                                terms: (chunks) => (
                                    <Link textDecoration='underline' to='/my-rewards'>
                                        {chunks}
                                    </Link>
                                ),
                                customer: (chunks) => (
                                    <Link
                                        textDecoration='underline'
                                        href={getSiteEnvVarValue(appConfig, 'CUSTOMER_SERVICE_URL', siteId)}
                                        target='_blank'
                                        rel="noopener noreferrer">
                                        {chunks}
                                    </Link>
                                )
                            }}
                        />
                    </Text>
                )}
            </Box>
        </Box>
    )
}

export default FAQ
